import { Config, PerEnvironmentConfigs } from '@/config/config'
import '@vgw/multibrand-fe-styles/css/themes/unitedslots.css'

const GRAFANA_APP_NAME = 'Unitedslots'
const BRAND_NAME = 'United Slots'
const BRAND_CODE = 'UNI'

const devConfig: Config = {
  name: `${BRAND_NAME}`,
  code: `${BRAND_CODE}`,
  keycloak: {
    url: 'https://auth.unitedslots-dev.com/realms',
    realm: 'UNI',
    clientId: 'unitedslots-spa',
  },

  gamGalleryViewApiUrl: 'https://api.gap-dev.vgwgames.com/gallery/view',
  gamGalleryUserPreferencesApiUrl:
    'https://api.gap-dev.vgwgames.com/preferences',
  gamGalleryTickersApiUrl: 'https://api.gap-dev.vgwgames.com/tickers',
  pamPlayerTokensApiUrl: 'https://pam.unitedslots-dev.com/player-tokens',
  pamStoreApiUrl: 'https://pam.unitedslots-dev.com/store/v1',
  pamAmoeApiUrl: 'https://pam.unitedslots-dev.com/pay-hub',
  pamAccountApiUrl: 'https://pam.unitedslots-dev.com/player-identity',
  pamKycApiUrl: 'https://pam.unitedslots-dev.com/kyc',
  pamNotificationsInboxApiUrl: 'https://pam.unitedslots-dev.com/communications',
  pamPlayerTokensHistoryApiUrl:
    'https://pam.unitedslots-dev.com/player-tokens-history',
  pamRedemptionApiUrl: 'https://pam.unitedslots-dev.com/pay-hub',
  gamPeriodicBonusServiceApiUrl: 'https://api.gap-dev.vgwgames.com',
  payPurchasesApiUrl: 'https://payments.dev.vgwgroup.net',
  payRedemptionsApiUrl: 'https://payments.dev.vgwgroup.net',
  pamRsgApiUrl: 'https://pam.unitedslots-dev.com',
  pamPurchaseLimitsApiUrl: 'https://pam.unitedslots-dev.com',
  gamGameRoundInfoApiUrl: 'https://api.gap-dev.vgwgames.com',
  gamQuestsPlayerApiUrl: 'https://api.gap-dev.vgwgames.com',
  amplitude: {
    apiKey: 'f297f98a850beae9b5108b977577aab6',
    loggingEnabled: false,
    region: 'EU',
    deploymentKey: 'client-KGOclx8AnqsWjcpFmO2CJjsBul3XpZWx',
  },
  helpCenterFormUrl:
    'https://vgw--develop.sandbox.my.site.com/HelpLWR/contact-form',
  helpCenterUrl: 'https://vgw--stage.sandbox.my.site.com/UNI/',
  // hero banner type by page
  heroBannerType: {
    lobby: 'carouselOverlayed',
    category: 'simple',
  },
  features: {
    isAvailableToPlayers: false,
    isHeroBannerEnabled: true,
  },
  braze: {
    apiKey: '523fa957-5609-40d1-be9a-91f3d8ccebd4',
    baseUrl: 'sdk.iad-01.braze.com',
  },
  postalRequestMoreInfoUrl:
    'https://pam.unitedslots-dev.com/legal/sweeps-rules',
  pamLegalDocumentsUrl: 'https://pam.unitedslots-dev.com/legal',
  ageRestriction: 21,
  grafana: {
    isEnabled: true,
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/65fc4c0c5f62d8014dcba8b8e9b94a54',
    appName: GRAFANA_APP_NAME,
  },
  minimumRedemptionThreshold: 10000,
  mobileMenuNavbar: {
    variant: 'tertiary',
  },
  defaultCurrency: 'USD',
  socialMediaLinks: {
    facebook: 'https://www.facebook.com/UnitedSlots',
    instagram: 'https://www.instagram.com/UnitedSlots',
    x: 'https://www.x.com/@UnitedSlots',
  },
  playForFreeSocialLink: 'https://www.facebook.com/UnitedSlots',
  cookieNoticeLink: 'https://unitedslots.com/legal/cookie-notice',
}

const testConfig: Config = {
  name: `${BRAND_NAME}`,
  code: `${BRAND_CODE}`,
  keycloak: {
    url: 'https://auth.unitedslots-test.com/realms',
    realm: 'UNI',
    clientId: 'unitedslots-spa',
  },

  gamGalleryViewApiUrl: 'https://api.gap-test.vgwgames.com/gallery/view',
  payPurchasesApiUrl: 'https://payments.test.vgwgroup.net',
  payRedemptionsApiUrl: 'https://payments.test.vgwgroup.net',
  gamGalleryUserPreferencesApiUrl:
    'https://api.gap-test.vgwgames.com/preferences',
  gamQuestsPlayerApiUrl: 'https://api.gap-test.vgwgames.com',
  gamGalleryTickersApiUrl: 'https://api.gap-test.vgwgames.com/tickers',
  pamStoreApiUrl: 'https://pam.unitedslots-test.com/store/v1',
  pamAmoeApiUrl: 'https://pam.unitedslots-test.com/pay-hub',
  pamAccountApiUrl: 'https://pam.unitedslots-test.com/player-identity',
  pamPlayerTokensHistoryApiUrl:
    'https://pam.unitedslots-test.com/player-tokens-history',
  pamRsgApiUrl: 'https://pam.unitedslots-test.com',
  gamGameRoundInfoApiUrl: 'https://api.gap-test.vgwgames.com',
  pamRedemptionApiUrl: 'https://pam.unitedslots-test.com/pay-hub',
  gamPeriodicBonusServiceApiUrl: 'https://api.gap-test.vgwgames.com',
  pamPurchaseLimitsApiUrl: 'https://pam.unitedslots-test.com',
  pamPlayerTokensApiUrl: 'https://pam.unitedslots-test.com/player-tokens',
  pamKycApiUrl: 'https://pam.unitedslots-test.com/kyc',
  pamNotificationsInboxApiUrl:
    'https://pam.unitedslots-test.com/communications',
  amplitude: {
    apiKey: '103f666bd0d7a3801a30213b365e53fa',
    loggingEnabled: false,
    region: 'EU',
    deploymentKey: 'client-lj9GB0oUybqOyDZo2bEzH2Wt05mDVAyt',
  },
  helpCenterFormUrl:
    'https://vgw--stage.sandbox.my.site.com/HelpLWR/contact-form/',
  helpCenterUrl: 'https://vgw--stage.sandbox.my.site.com/UNI/',
  heroBannerType: {
    lobby: 'carouselOverlayed',
    category: 'simple',
  },
  features: {
    isHeroBannerEnabled: true,
    isAvailableToPlayers: false,
  },
  braze: {
    apiKey: '523fa957-5609-40d1-be9a-91f3d8ccebd4',
    baseUrl: 'sdk.iad-01.braze.com',
  },
  postalRequestMoreInfoUrl:
    'https://pam.unitedslots-test.com/legal/sweeps-rules',
  pamLegalDocumentsUrl: 'https://pam.unitedslots-test.com/legal',
  ageRestriction: 21,
  grafana: {
    isEnabled: true,
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/279a9bd0c73f7cbf2edba058040a2d36',
    appName: GRAFANA_APP_NAME,
  },
  minimumRedemptionThreshold: 10000,
  mobileMenuNavbar: {
    variant: 'tertiary',
  },
  defaultCurrency: 'USD',
  socialMediaLinks: {
    facebook: 'https://www.facebook.com/UnitedSlots',
    instagram: 'https://www.instagram.com/UnitedSlots',
    x: 'https://www.x.com/@UnitedSlots',
  },
  playForFreeSocialLink: 'https://www.facebook.com/UnitedSlots',
  cookieNoticeLink: 'https://unitedslots.com/legal/cookie-notice',
}

const productionConfig: Config = {
  name: `${BRAND_NAME}`,
  code: `${BRAND_CODE}`,
  keycloak: {
    url: 'https://auth.unitedslots.com/realms',
    realm: 'UNI',
    clientId: 'unitedslots-spa',
  },
  gamGalleryViewApiUrl: 'https://api.gap.vgwgames.com/gallery/view',
  gamGalleryUserPreferencesApiUrl: 'https://api.gap.vgwgames.com/preferences',
  gamGalleryTickersApiUrl: 'https://api.gap.vgwgames.com/tickers',
  pamPlayerTokensApiUrl: 'https://pam.unitedslots.com/player-tokens',
  pamKycApiUrl: 'https://pam.unitedslots.com/kyc',
  pamNotificationsInboxApiUrl: 'https://pam.unitedslots.com/communications',
  gamQuestsPlayerApiUrl: 'https://api.gap.vgwgames.com',
  pamStoreApiUrl: 'https://pam.unitedslots.com/store/v1',
  pamAmoeApiUrl: 'https://pam.unitedslots.com/pay-hub',
  pamAccountApiUrl: 'https://pam.unitedslots.com/player-identity',
  pamPlayerTokensHistoryApiUrl:
    'https://pam.unitedslots.com/player-tokens-history',
  pamRsgApiUrl: 'https://pam.unitedslots.com',
  gamGameRoundInfoApiUrl: 'https://api.gap.vgwgames.com',
  pamRedemptionApiUrl: 'https://pam.unitedslots.com/pay-hub',
  gamPeriodicBonusServiceApiUrl: 'https://api.gap.vgwgames.com',
  payPurchasesApiUrl: 'https://payments.vgwgroup.net',
  payRedemptionsApiUrl: 'https://payments.vgwgroup.net',
  amplitude: {
    apiKey: '7f658597651713a23e67e1c1bdd0352f',
    loggingEnabled: false,
    region: 'EU',
    deploymentKey: 'client-lj9GB0oUybqOyDZo2bEzH2Wt05mDVAyt',
  },
  pamPurchaseLimitsApiUrl: 'https://pam.unitedslots.com',
  helpCenterFormUrl:
    'https://vgw--stage.sandbox.my.site.com/HelpLWR/contact-form',
  helpCenterUrl: 'http://help.unitedslots.com/',
  heroBannerType: {
    lobby: 'carouselOverlayed',
    category: 'simple',
  },
  features: {
    isHeroBannerEnabled: true,
    isAvailableToPlayers: false,
  },
  braze: {
    apiKey: 'bd03634f-dd59-4177-90e4-50a1a3ea9a61',
    baseUrl: 'sdk.iad-01.braze.com',
  },
  postalRequestMoreInfoUrl: '',
  pamLegalDocumentsUrl: 'https://pam.unitedslots.com/legal',
  ageRestriction: 21,
  grafana: {
    isEnabled: true,
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/fa4bcfbc70d623f621edb2c2da710543',
    appName: GRAFANA_APP_NAME,
  },
  minimumRedemptionThreshold: 10000,
  mobileMenuNavbar: {
    variant: 'tertiary',
  },
  defaultCurrency: 'USD',
  socialMediaLinks: {
    facebook: 'https://www.facebook.com/UnitedSlots',
    instagram: 'https://www.instagram.com/UnitedSlots',
    x: 'https://www.x.com/@UnitedSlots',
  },
  playForFreeSocialLink: 'https://www.facebook.com/UnitedSlots',
  cookieNoticeLink: 'https://unitedslots.com/legal/cookie-notice',
}

const BRAND_CONFIGS: PerEnvironmentConfigs = {
  local: {
    ...devConfig,
    grafana: {
      isEnabled: false,
    },
  },
  dev: {
    ...devConfig,
  },
  test: {
    ...testConfig,
  },
  prod: {
    ...productionConfig,
  },
}

export default BRAND_CONFIGS
